import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 26, testid }) => {
  // During prerender + hydration, render the final visible state (no scroll
  // animation) so raw HTML has no invisible opacity:0 content and hydration
  // markup matches. Scroll animations run for later client-side navigation.
  if (typeof window !== "undefined" && window.__WP_STATIC__ === true) {
    return (
      <div data-testid={testid} className={className}>
        {children}
      </div>
    );
  }
  return (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const Pill = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full bg-[#ecfdf3] px-4 py-1.5 text-xs font-bold tracking-wide text-[#16a34a] ${className}`}
  >
    {children}
  </span>
);

export const SectionHeading = ({ overline, title, subtitle, center = false, onDark = false }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {overline && (
      <span
        className={`inline-block text-xs tracking-[0.18em] uppercase font-bold mb-4 ${
          onDark ? "text-[#21c55e]" : "text-[#16a34a]"
        }`}
      >
        {overline}
      </span>
    )}
    <h2
      className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] font-extrabold tracking-tight ${
        onDark ? "text-white" : "text-[#091630]"
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-4 text-base sm:text-lg leading-relaxed ${onDark ? "text-slate-300" : "text-slate-500"}`}>
        {subtitle}
      </p>
    )}
  </div>
);
